import { OrganisationTable } from "@/app/Organisations/Components/OrganisationTable";
import { FullPageScreen } from "@/lib/Components/Screens/FullPageScreen";

export function OrganisationListScreen() {
  return (
    <FullPageScreen>
      <h3 className="pb-2.5 text-base font-semibold leading-6 text-gray-900">
        Organisations
      </h3>
      <OrganisationTable id="settings-organisations" />
    </FullPageScreen>
  );
}
